import React, { Component } from 'react'
import { localize, getLocale } from '../../util/Localizer'
import { Row, Col } from 'react-flexbox-grid'
import NgrxDate from '../../util/NgrxDateHelper'
import RBButton from '../../controls/RBButton'
import Icon from '@material-ui/core/Icon'
import { withStyles } from '@material-ui/core/styles'
import { fetchEOBFile } from '../../redux/actions/eobActions'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import NotificationSystem from 'react-notification-system'
import GenericModal from '../../widgets/common/GenericModal'
import { formatCurrency } from '../../util/CurrencyFormatter'
import IconStyles from '../../styles/icons'
import NotificationStyles from '../../styles/components/react-notification-system'

class ClaimLinePayment extends Component {
  // const ClaimLinePayment = (props, parent) => {
  constructor (props) {
    super(props)
    this.fileDownloadError = this.fileDownloadError.bind(this)
    this.downloadEOBFile = this.downloadEOBFile.bind(this)
    this.notificationSystem = React.createRef()
    this.state = { showGenericModal: false }
  }

  fetchEoBFile (fileName) {
    this.props.fetchEOBFile(fileName, this.downloadEOBFile, this.fileDownloadError)
  }

  fileDownloadError () {
    const notification = this.notificationSystem.current
    const { downloadError = {} } = this.props
    const { rawResponse, message } = downloadError
    if (notification === undefined) { return }

    // clear all notifications
    notification.clearNotifications()

    // show the notification if available
    if (downloadError) {
      const serverError = downloadError && rawResponse && rawResponse.error_description
      notification.addNotification({
        title: `${serverError || message}`,
        level: 'error',
        position: 'tc',
        autoDismiss: 0
      })
    }
  }

  downloadEOBFile () {
    /*eslint-disable */
    if (typeof (this.props.eobFile) === 'object' && !this.props.eobFile.hasErrorField) {
      this.props.eobFile.map((file, index) => {
        const pdfFielBlob = this.b64toBlob(file.fileContentField, 'application/pdf')
        const fileName = file.fileNameField
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
          window.navigator.msSaveOrOpenBlob(pdfFielBlob, fileName)
        } else {
          var downloadLink = document.createElement('a')
          downloadLink.download = fileName
          downloadLink.innerHTML = 'Download File'
          var URL = window.URL || window.webkitURL
          downloadLink.href = URL.createObjectURL(pdfFielBlob)
          if (!('webkitURL' in window)) {
            // Firefox requires the link to be added to the DOM before it can be clicked.
            downloadLink.href = URL.createObjectURL(pdfFielBlob)
            downloadLink.onclick = this.destroyDowloadLink
            downloadLink.style.display = 'none'
            document.body.appendChild(downloadLink)
          }

          downloadLink.click()
          URL.revokeObjectURL(downloadLink)
        }
      })
    } else {
      this.setState({showGenericModal: true})
    }
  }
  /* eslint-enable */
  b64toBlob (b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = window.atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new window.Blob(byteArrays, { type: contentType })
    return blob
  }

  destroyDowloadLink (event) {
    document.body.removeChild(event.target)
  }

  render () {
    const { classes = {} } = this.props
    const payment = this.props.payment
    const lang = getLocale()

    return (
      <div>
        <Row className='claimLineRow' between='xs'>
          <Col xs={12} sm={4} lg={2}>
            <p><span className='bold'>{localize('pages.claims.claimLineDetails.claimPayment')}</span></p>
          </Col>
          <Col xs={12} sm={4} lg={3}>
            <p>{localize('pages.claims.claimLineDetails.paymentRefNum')} <span className='bold'>{payment.paymentReferenceNumber}</span></p>
          </Col>
          <Col xs={12} sm={4} lg={3}>
            <p>{localize('pages.claims.claimLineDetails.paymentDate')} <span className='bold'>{NgrxDate.SetDate(payment.paymentDate)}</span></p>
          </Col>
          <Col xs={12} sm={4} lg={2}>
            <p><span className='bold'>{ formatCurrency(payment.paymentAmmount) }</span></p>
          </Col>
          {payment.fileExists === true
            ? <Col xs={12} sm={lang === 'en' ? 4 : 6} lg={lang === 'en' ? 2 : 4}>
              <RBButton
                label={localize('pages.claims.eob')}
                variant='outlined'
                onClick={() => { this.fetchEoBFile(payment.fileName) }}
                icon={<Icon className={classes.borderedIcon}>arrow_downward</Icon>} />

            </Col>
            : null}
          <NotificationSystem ref={this.notificationSystem} style={NotificationStyles} />
          {this.state.showGenericModal ? <GenericModal
            open={this.state.showGenericModal}
            handleClose={() => {
              this.setState({ showGenericModal: false })
            }}
            modal
            message='Something went wrong while downloading resource. Please try again'
          /> : null}
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state, props) {
  return {
    payment: props.payment,
    downloadError: state.EOBReducer.error,
    eobFile: state.EOBReducer.eobFile || ''
  }
}

const ConnectedClaimLinePayment = connect(mapStateToProps, { fetchEOBFile })(injectIntl(ClaimLinePayment))

const Styles = {
  ...IconStyles
}

export default withStyles(Styles)(ConnectedClaimLinePayment)



// WEBPACK FOOTER //
// ./src/widgets/Claims/ClaimLinePayment.js